import React, { useState } from 'react'
import Sidebar from '../Component/Sidebar'
import Loader from '../Component/Loader'

const ExportReport = () => {
    const [isLoading,setIsLoading] = useState(false);
  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            <p className="admin_title">Export Report</p>
            
          </div>
        </div>
      )}
    </>
  )
}

export default ExportReport